import { render, staticRenderFns } from "./ConfigSelectEgdsIndicazioneList.vue?vue&type=template&id=35615b54"
import script from "./ConfigSelectEgdsIndicazioneList.vue?vue&type=script&lang=js"
export * from "./ConfigSelectEgdsIndicazioneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports